import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from '@emotion/styled';
import { useBundle } from '@amzn/react-arb-tools';
import { useParams, useSearchParams } from 'react-router';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { useAnalyticsContext } from 'src/common/metrics';
import { useProductReviews } from 'src/hooks/useProductReviews';
import { MarketplaceIds } from 'src/utils/links';
import { StarRating } from 'src/common/starRating';
import { UserIcon } from 'src/common/icons';
import { RioText } from 'src/common/styled';
import { ReviewImages } from './ReviewImages';
import { ReviewText } from './ReviewText';
export const VariationText = styled(RioText) `
  &:not(:last-child)::after {
    content: '•';
    margin: 0px 4px;
  }
`;
export const PurchaseTypeText = styled(Text) `
  color: ${({ isVine, theme }) => isVine ? theme.rio.base.color.green[(theme === null || theme === void 0 ? void 0 : theme.mode) === 'dark' ? 600 : 400] : theme.rio.semantic.color.retail.stars};

  &:not(:last-child)::after {
    content: '•';
    margin-left: 4px;
    color: ${({ theme }) => theme.rio.semantic.color.font.primary};
  }
`;
export const ProductReviews = () => {
    var _a;
    const { asin } = useParams();
    const rumClient = useAnalyticsContext();
    const [bundle, isBundleLoading] = useBundle('pages.productDetails');
    const [searchParams] = useSearchParams();
    const marketplaceId = searchParams.get('marketplaceId') || MarketplaceIds.US;
    const { data: reviewsData, isLoading, isError, error } = useProductReviews();
    React.useEffect(() => {
        if (isError) {
            rumClient.recordEvent('PRODUCT_REVIEWS_FETCH_ERROR', {
                errorTitle: error === null || error === void 0 ? void 0 : error.title,
                errorDetails: error === null || error === void 0 ? void 0 : error.detail,
                asin: asin,
            });
        }
    }, [isError, error]);
    if (isBundleLoading || isLoading || isError || !((_a = reviewsData === null || reviewsData === void 0 ? void 0 : reviewsData.topReviews) === null || _a === void 0 ? void 0 : _a.length)) {
        return null;
    }
    return (_jsxs(Column, { spacingInset: "350 350 none 350", spacing: "350", "data-testid": "product-reviews", children: [_jsx(Text, { type: "h200", children: bundle.formatMessage('topReviews', { marketplace: marketplaceId }) }), reviewsData.topReviews.map((review, idx) => {
                var _a, _b, _c;
                return (_jsxs(Column, { spacing: "200", "data-testid": "review-entry", children: [_jsxs(Row, { spacing: "300", alignmentVertical: "center", "data-testid": "reviewer-info", children: [_jsx(UserIcon, {}), _jsx(RioText, { rioColor: "secondary", type: "b200", "data-testid": "reviewer-name", children: bundle.getMessage('amazonCustomer') })] }), _jsxs(Row, { spacing: "200", wrap: "down", alignmentVertical: "center", "data-testid": "rating-and-purchase-types", children: [_jsx(StarRating, { rating: review.rating || 0 }), (_a = review.purchaseTypes) === null || _a === void 0 ? void 0 : _a.map((purchaseType, idx) => (_jsx(PurchaseTypeText, { "data-testid": "purchase-type", isVine: purchaseType.toLowerCase().includes('vine'), type: "b100", children: _jsx("b", { children: purchaseType }) }, idx)))] }), _jsxs("div", { "data-testid": "review-content", children: [_jsx(Text, { type: "h50", "data-testid": "review-title", children: review.title }), _jsx(RioText, { rioColor: "secondary", type: "b100", "data-testid": "review-date", children: review.date }), !!((_b = review.variation) === null || _b === void 0 ? void 0 : _b.length) && (_jsx(Row, { spacing: "none", wrap: "down", "data-testid": "review-variations", children: review.variation.map((variation, idx) => (_jsxs(VariationText, { rioColor: "secondary", type: "b100", children: [variation.key, ": ", variation.value] }, idx))) }))] }), !!((_c = review.images) === null || _c === void 0 ? void 0 : _c.length) && _jsx(ReviewImages, { images: review.images }), !!review.text && _jsx(ReviewText, { text: review.text })] }, idx));
            })] }));
};
